// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"fa85815d","910":"d1579c69"}[chunkId] + ".chunk.css";
};